export default "__VITE_ASSET__gr3_58VY__"